export default {
    state: { 
        isAdmin:false,
        account:{},
     },
    mutations: {
        // SETAUTH(state,user){
        //     state.isAdmin = true
        //     state.account = user
        // }
     },
    actions: {

     }
  }